import gql from 'graphql-tag'

export const getContacts = gql`
  query($paging: PagingQuery, $order: ContactsOrder, $filter: ContactsFilter!) {
    getContacts(
      filter: $filter,
      order: $order,
      paging: $paging
    ) {
      contacts {
        id
        name
        recordType {
          id
          name
        }
        salutation
        title
        doNotCall
        textOptOut
        emailOptOut
        department
        phone
        extensionNumber
        countryCode
        countryCallingCode
        otherPhone
        otherExtensionNumber
        otherCountryCode
        otherCountryCode
        mobile
        mobileCountryCode
        mobileCountryCallingCode
        mobileExtensionNumber
        email
        otherEmail
        fax
        faxCountryCode
        faxCountryCallingCode
        faxExtensionNumber
        otherAddressCountry
        otherAddressState
        otherAddressPostalCode
        otherAddressCity
        otherAddressStreet
        mailingAddressCountry
        mailingAddressState
        mailingAddressPostalCode
        mailingAddressCity
        mailingAddressStreet
        extension
        socialContacts
        createdAt
        updatedAt
        lastModifiedBy {
          id
          username
        }
        additionalInfoStr
        createdBy {
          id
          username
        }
        accounts {
          id
          name
        }
        relatedAccounts {
          id
          name
        }
        accountName {
          id
          name
        }
        source {
          id
          name
        }
      }
      paging{ totalCount currentOffset currentLimit }
    }
  }
`

export const getCandidateContacts = gql`
  query($paging: PagingQuery, $filter: ContactsFilter!) {
    getContacts(
      filter: $filter,
      paging: $paging
    ) {
      contacts {
        id
        name
      }
    }
  }
`

export const getContact = gql`
  query($contactId: Int!) {
    getContact(
      contactId: $contactId
    ) {
      id
      name
      recordType {
        id
        name
      }
      salutation
      title
      doNotCall
      textOptOut
      emailOptOut
      department
      phone
      extensionNumber
      countryCode
      countryCallingCode
      otherPhone
      otherCountryCode
      otherCountryCallingCode
      otherExtensionNumber
      mobile
      mobileCountryCode
      mobileExtensionNumber
      mobileCountryCallingCode
      email
      otherEmail
      fax
      faxCountryCode
      faxCountryCallingCode
      faxExtensionNumber
      otherAddressCountry
      otherAddressState
      otherAddressPostalCode
      otherAddressCity
      otherAddressStreet
      mailingAddressCountry
      mailingAddressState
      mailingAddressPostalCode
      mailingAddressCity
      mailingAddressStreet
      extension
      socialContacts
      additionalInfoStr
      createdAt
      updatedAt
      lastModifiedBy {
        id
        username
      }
      createdBy {
        id
        username
      }
      accounts {
        id
        name
        phone
        extensionNumber
        countryCode
        countryCallingCode
        otherPhone
        otherExtensionNumber
        otherCountryCode
        otherCountryCallingCode
        birthday
        recordType {
          id
          name
        }
        notes
        billingAddressCountry
        billingAddressState
        billingAddressPostalCode
        billingAddressCity
        billingAddressStreet
        mailingAddressCountry
        mailingAddressState
        mailingAddressPostalCode
        mailingAddressCity
        mailingAddressStreet
        additionalInfoStr
        createdAt
        updatedAt
        lastModifiedBy {
          id
          username
        }
        createdBy {
          id
          username
        }
        parentAccount {
          id
          name
        }
        source {
          id
          name
        }
        primaryContact {
          id
          name
        }
      }
      relatedAccounts {
        id
        name
        phone
        extensionNumber
        countryCode
        countryCallingCode
        otherPhone
        otherExtensionNumber
        otherCountryCode
        otherCountryCallingCode
        birthday
        recordType {
          id
          name
        }
        notes
        billingAddressCountry
        billingAddressState
        billingAddressPostalCode
        billingAddressCity
        billingAddressStreet
        mailingAddressCountry
        mailingAddressState
        mailingAddressPostalCode
        mailingAddressCity
        mailingAddressStreet
        additionalInfoStr
        createdAt
        updatedAt
        lastModifiedBy {
          id
          username
        }
        createdBy {
          id
          username
        }
        parentAccount {
          id
          name
        }
        source {
          id
          name
        }
        primaryContact {
          id
          name
        }
      }
      accountName {
        id
        name
      }
      source {
        id
        name
      }
      quotes {
        id
        name
        status
        type
        originalInceptionDate
        commissionPaymentEffectiveDate
        commissionPaymentExpirationDate
        currentCoverage
        closed
        createdAt
        updatedAt
        federalEmployerIdNumber
        additionalInfoStr
        caseId
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        source {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        recordType {
          id
          name
        }
        createdBy {
          id
          username
        }
        lastModifiedBy {
          id
          username
        }
      }
      policies {
        id
        policyName
        status
        closeDate
        effectiveDate
        expirationDate
        originalInceptionDate
        brokerFee
        agencyFee
        carrierPolicyFee
        inspectionFee
        taxesFee
        stampingFee
        premium
        policyNumber
        term
        bindDate
        payerType
        closed
        createdAt
        updatedAt
        productCommissionOverride
        caseId
        additionalInfoStr
        installmentPlan
        billingType
        isPremiumPayOff
        isCommissionPayOff
        caseId
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        source {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        recordType {
          id
          name
        }
        insuranceQuote {
          id
          name
        }
      }
      attachments {
        id
        type
        name
        size
        createdAt
        updatedAt
      }
    }
  }
`

export const newContact = gql`
  mutation($accountId: Int, $contactInput: ContactInput!) {
    newContact(
      accountId: $accountId,
      contactInput: $contactInput
    ) {
      id
      name
    }
  }
`

export const editContact = gql`
  mutation($contactId: Int!, $contactInput: ContactInput!) {
    editContact(
      contactId: $contactId,
      contactInput: $contactInput
    ) {
      id
      name
      recordType {
        id
        name
      }
      salutation
      title
      doNotCall
      textOptOut
      emailOptOut
      department
      phone
      extensionNumber
      countryCode
      countryCallingCode
      otherPhone
      otherExtensionNumber
      otherCountryCode
      otherCountryCallingCode
      mobile
      mobileCountryCode
      mobileCountryCallingCode
      mobileExtensionNumber
      email
      otherEmail
      fax
      faxCountryCode
      faxCountryCallingCode
      faxExtensionNumber
      otherAddressCountry
      otherAddressState
      otherAddressPostalCode
      otherAddressCity
      otherAddressStreet
      mailingAddressCountry
      mailingAddressState
      mailingAddressPostalCode
      mailingAddressCity
      mailingAddressStreet
      extension
      socialContacts
      createdAt
      updatedAt
      lastModifiedBy {
        id
        username
      }
      createdBy {
        id
        username
      }
      additionalInfoStr
      accounts {
        id
        name
      }
      relatedAccounts {
        id
        name
      }
      accountName {
        id
        name
      }
      source {
        id
        name
      }
    }
  }
`

export const deleteContact = gql`
  mutation($contactId: Int!) {
    deleteContact(
      contactId: $contactId
    )
  }
`

export const getGlobalSearchContacts = gql`
  query($query: String!, $order: ContactsOrder!, $paging: PagingQuery!) {
    globalSearchContacts(
      query: $query,
      order: $order,
      paging: $paging
    ) {
      contacts {
        id
        name
        phone
        extensionNumber
        countryCode
        countryCallingCode
        otherPhone
        otherExtensionNumber
        otherCountryCode
        otherCountryCallingCode
        mailingAddress
        otherAddress
      }
    }
  }
`

export const getAllGlobalSearchContacts = gql`
  query($query: String!, $order: ContactsOrder!, $paging: PagingQuery!) {
    globalSearchContacts(
      query: $query,
      order: $order,
      paging: $paging
    ) {
      contacts {
        id
        name
        accounts {
          id
          name
        }
        title
        phone
        extensionNumber
        countryCode
        email
      }
      paging{ totalCount currentOffset currentLimit }
    }
  }
`
